export default __webpack_public_path__ + "static/media/tab_lecturer1_large.3a2b5daa.png";